module.exports = __webpack_public_path__ + "img/img9.47eee50b.jpg";